module.exports = __webpack_public_path__ + "static/media/nz-logo.95a33cf4.svg";